import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Button, IButton } from './button';

export const ButtonGroup: FunctionComponent<IButtonGroup> = ({
  options,
  selectedOption,
  onSelectOption,
  ...buttonProps
}) => {
  return (
    <Container className="button-group">
      {options?.map((option, idx) => {
        const isSelected = selectedOption
          ? option.id === selectedOption
          : idx === 0;

        return (
          <Button
            {...buttonProps}
            key={option.id}
            mType={isSelected ? 'primary' : 'secondary'}
            onClick={() => onSelectOption(option)}
          >
            {option.title}
          </Button>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  display: flex;

  button {
    opacity: 1 !important;

    &:not(:first-of-type) {
      border-left: 0;
    }
  }
`;

interface IButtonGroup extends Omit<IButton, 'mType' | 'loading'> {
  options?: { id: string; title: string }[];
  selectedOption?: string;
  onSelectOption: (option: { id: string; title: string }) => void;
}
